export interface FloatingSidebarPersistedState {
  left: number;
  top: number;
  width: number;
  height: number;
}

const PREFIX = "xgs-floating-sidebar";

export function getFloatingSidebarStorageKey(instanceKey: string): string {
  return `${PREFIX}:${instanceKey}`;
}

export function loadFloatingSidebarState(
  instanceKey: string
): FloatingSidebarPersistedState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(getFloatingSidebarStorageKey(instanceKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      typeof (parsed as FloatingSidebarPersistedState).left !== "number" ||
      typeof (parsed as FloatingSidebarPersistedState).top !== "number" ||
      typeof (parsed as FloatingSidebarPersistedState).width !== "number" ||
      typeof (parsed as FloatingSidebarPersistedState).height !== "number"
    ) {
      return null;
    }
    return parsed as FloatingSidebarPersistedState;
  } catch {
    return null;
  }
}

export function saveFloatingSidebarState(
  instanceKey: string,
  state: FloatingSidebarPersistedState
): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      getFloatingSidebarStorageKey(instanceKey),
      JSON.stringify(state)
    );
  } catch {
    // ignore quota / private mode
  }
}
